import { useState } from 'react'

import { getAPI } from 'utils/getAPI'

import type { ResponseResult, SavePostUploadDataTypePostRequest } from 'api-client'
import type { ErrorResponse } from 'types/types'


export const useUpload = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [result, setResult] = useState<ResponseResult | undefined>(undefined)

  const fetchUpload = async (searchParam: SavePostUploadDataTypePostRequest) => {
    setIsLoading(true)
    setResult(undefined)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.savePostUploadDataTypePost(searchParam)
      setResult(response.result)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      // eslint-disable-next-line no-console
      console.log(error.response)
      // eslint-disable-next-line no-console
      console.log(typeof error.response)
      const errorResult: ResponseResult = {
        status: 'error',
        message: `ファイルアップロードでエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      }
      setResult(errorResult)
      return { result: errorResult }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    result,
    fetchUpload,
    isLoading,
  }
}
